var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "table-filter-pill-root"
  }, [_vm.isBooleanFilter ? [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-delay": "300"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var tooltipOn = _ref.on,
          tooltipAttrs = _ref.attrs;
        return [_vm.active ? _c('button', _vm._g(_vm._b({
          staticClass: "table-filter-pill table-filter-pill--active",
          attrs: {
            "type": "button",
            "aria-label": _vm.badgeAriaLabel
          }
        }, 'button', tooltipAttrs, false), tooltipOn), [_c('span', {
          staticClass: "table-filter-pill__label"
        }, [_vm.labelLoading ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "size": "14",
            "width": "2",
            "color": "primary"
          }
        }) : [_vm._v(_vm._s(_vm.badgeLabel))]], 2), _c('span', {
          staticClass: "table-filter-pill__remove",
          attrs: {
            "role": "button",
            "tabindex": "0",
            "aria-label": _vm.removeLabel
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.clearFilter.apply(null, arguments);
            },
            "keyup": function keyup($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              $event.stopPropagation();
              return _vm.clearFilter.apply(null, arguments);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v("mdi-close")])], 1)]) : _c('button', _vm._g(_vm._b({
          staticClass: "table-filter-pill table-filter-pill--inactive",
          attrs: {
            "type": "button",
            "aria-label": _vm.filter.label
          },
          on: {
            "click": _vm.applyBooleanFilter
          }
        }, 'button', tooltipAttrs, false), tooltipOn), [_c('span', [_vm._v(_vm._s(_vm.filter.label))])])];
      }
    }], null, false, 700195038)
  }, [_c('span', [_vm._v(_vm._s(_vm.filterTooltip))])])] : _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "offset-y": "",
      "transition": "scale-transition",
      "max-width": "360",
      "min-width": "280"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var menuOn = _ref2.on,
          menuAttrs = _ref2.attrs;
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "open-delay": "300"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref3) {
              var tooltipOn = _ref3.on,
                tooltipAttrs = _ref3.attrs;
              return [_vm.active ? _c('button', _vm._g(_vm._b({
                staticClass: "table-filter-pill table-filter-pill--active",
                attrs: {
                  "type": "button",
                  "aria-label": _vm.badgeAriaLabel
                }
              }, 'button', Object.assign({}, menuAttrs, tooltipAttrs), false), Object.assign({}, menuOn, tooltipOn)), [_c('span', {
                staticClass: "table-filter-pill__label"
              }, [_vm._v(" " + _vm._s(_vm.badgeLabel) + " "), _vm.labelLoading ? _c('v-progress-circular', {
                staticClass: "ml-1",
                attrs: {
                  "indeterminate": "",
                  "size": "14",
                  "width": "2",
                  "color": "primary"
                }
              }) : _vm._e()], 1), _vm.filter.clearable !== false ? _c('span', {
                staticClass: "table-filter-pill__remove",
                attrs: {
                  "role": "button",
                  "tabindex": "0",
                  "aria-label": _vm.removeLabel
                },
                on: {
                  "click": function click($event) {
                    $event.stopPropagation();
                    return _vm.clearFilter.apply(null, arguments);
                  },
                  "keyup": function keyup($event) {
                    if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
                    $event.stopPropagation();
                    return _vm.clearFilter.apply(null, arguments);
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "x-small": ""
                }
              }, [_vm._v("mdi-close")])], 1) : _c('v-icon', {
                staticClass: "table-filter-pill__chevron",
                attrs: {
                  "x-small": ""
                }
              }, [_vm._v("mdi-chevron-down")])], 1) : _c('button', _vm._g(_vm._b({
                staticClass: "table-filter-pill table-filter-pill--inactive",
                attrs: {
                  "type": "button",
                  "aria-label": _vm.filter.label
                }
              }, 'button', Object.assign({}, menuAttrs, tooltipAttrs), false), Object.assign({}, menuOn, tooltipOn)), [_c('span', [_vm._v(_vm._s(_vm.filter.label))]), _c('v-icon', {
                staticClass: "table-filter-pill__chevron",
                attrs: {
                  "x-small": ""
                }
              }, [_vm._v("mdi-chevron-down")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.filterTooltip))])])];
      }
    }]),
    model: {
      value: _vm.menuOpen,
      callback: function callback($$v) {
        _vm.menuOpen = $$v;
      },
      expression: "menuOpen"
    }
  }, [_vm.usePillPanel && _vm.menuOpen ? _c('TableFilterPillPanel', {
    attrs: {
      "filter": _vm.filter,
      "value": _vm.filterValue,
      "filters": _vm.filters
    },
    on: {
      "change": _vm.onFilterChange,
      "close": function close($event) {
        _vm.menuOpen = false;
      }
    }
  }) : _c('v-card', {
    staticClass: "table-filter-pill__menu pa-3"
  }, [_c('FiltersItem', {
    attrs: {
      "filter": _vm.filter,
      "value": _vm.filterValue,
      "filters": _vm.filters
    },
    on: {
      "change": _vm.onFilterChange
    }
  })], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }